<div class="company-ss4-container">
  <document-upload-image
    [inputId]="'ss4-input'"
    [downloadLink]="ss4Uri"
    [isLoading]="isLoading"
    [isShowLoader]="!!companyId"
    [headerLabel]="'LABELS.SS4'"
    [badgeLabel]="badgeLabel"
    [badgeClass]="badgeClass"
    [descriptionHint]="'COMPANY.UPLOAD_SS4_HINT'"
    [uploadedFileLabel]="'LABELS.SS4'"
    [showRemoveButton]="false"
    [isNonImageDocument]="isNonImageDocument"
    [fileName]="fileName"
    [acceptAttribute]="acceptMimes"
    [allowDocumentFiles]="true"
    [allowedExtensions]="allowedExtensions"
    [extensionErrorKey]="'FORM_ERROR.SS4_FILE_TYPE'"
    [nonImageIconClass]="'fa-file-text-o'"
    (upload)="uploadSs4($event)"
  ></document-upload-image>
</div>
